import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NotFoundService {

    // -----------------------------------------------------------------------------------------------------
    // @ PRIVATE INSTANCE PROPERTIES
    // -----------------------------------------------------------------------------------------------------

    private _notFound = signal<boolean>(false);

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC INSTANCE PROPERTIES
    // -----------------------------------------------------------------------------------------------------

    /**
     * Publicly accessible if a not found error has occurred. This can be used to show a not found page or message to the user.
     */
    notFound = this._notFound.asReadonly();

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC METHODS
    // -----------------------------------------------------------------------------------------------------

    /**
     * Notifies the service that a not found error has occurred. This can be used to show a not found page or message to the user.
     *  
     * @param $event - A boolean value indicating whether a not found error has occurred. If true, the not found page or message will be shown to the user. If false, the not found page or message will be hidden from the user.
     * @returns {void}
     */
    notify($event: boolean = true): void {
        if ($event === true || $event === false) {
            this._notFound.set($event);
            return;
        }

        throw new Error(`[NOT FOUND SERVICE] ${$event} is not a valid value for notify`)
    }
}